<script>
import appConfig from "@/app.config";

import { notificationMethods } from "@/state/helpers";
import { mapGetters, mapActions } from "vuex";
// import WestoreAuth from "@/services/westore/auth";
export default {
  name: "app",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  created() {
    if (this.authenticated) {
      this.checkUserLang(this.lang);
    }
    // document.querySelector("html").setAttribute('dir', 'rtl')
  },
  computed: {
    ...mapGetters({
      authenticated: ["auth/authenticated"],
      lang: ["auth/lang"],
    }),
  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      this.clearNotification();
    },
  },
  methods: {
    ...mapActions({
      checkUserLang: "auth/changeLang",
    }),
    clearNotification: notificationMethods.clear,
  },
  //components: { Footer }
};
</script>

<template>
  <v-app :class="isRtl ? 'apply-ar-font' : ''">
    <RouterView />
  </v-app>
</template>
<style>
#app {
  background-color: #f0f0f5;
  font-family: "Lato-Regular";
}
.apply-ar-font {
  font-family: "Frutiger-bold" !important;
}
</style>
